import { c as _c } from "react/compiler-runtime";
import { ProfileActivityLogHandleEdit } from "@/entities/IProfile";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
export default function ProfileActivityLogHandle(t0) {
  const $ = _c(12);
  const {
    log
  } = t0;
  const isAdded = !log.contents.old_value;
  const t1 = isAdded ? "created" : "changed";
  let t2;
  if ($[0] !== t1) {
    t2 = <ProfileActivityLogItemAction action={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-whitespace-nowrap tw-text-base tw-text-iron-300 tw-font-medium">handle</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isAdded || $[4] !== log.contents.old_value) {
    t4 = !isAdded && <><span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-100">{log.contents.old_value}</span><svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentcOLOR" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></>;
    $[3] = isAdded;
    $[4] = log.contents.old_value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== log.contents.new_value) {
    t5 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{log.contents.new_value}</span>;
    $[6] = log.contents.new_value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = <>{t2}{t3}{t4}{t5}</>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}